/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuInputRangeDimensions_user$ref = any;
export type SbRespRefineMenuFilterDimensions_user$ref = any;
export type SbRespRefineMenuFilterDimensions_user = {
    readonly " $fragmentRefs": SbSharedRefineMenuInputRangeDimensions_user$ref;
    readonly " $refType": SbRespRefineMenuFilterDimensions_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterDimensions_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_user",
      "args": null
    }
  ]
};
(node as any).hash = '5c095c96fa002ff53f39d14e3317552f';
export default node;
